import { render, staticRenderFns } from "./GridCardBasic.vue?vue&type=template&id=6b73ca32&scoped=true&"
import script from "./GridCardBasic.vue?vue&type=script&lang=js&"
export * from "./GridCardBasic.vue?vue&type=script&lang=js&"
import style0 from "./GridCardBasic.vue?vue&type=style&index=0&id=6b73ca32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b73ca32",
  null
  
)

export default component.exports